<div class="bg-gray-50 p-5 border-b border-gray-200 font-light">
    <div class="max-w-7xl mx-auto">
        <div class="text-xl text-gray-800">Datenportal Query-Builder</div>
    </div>
</div>